import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getPaymentHistory, getPaymentMethod } from "@/features/billing/api";
import type { Subscription } from "@/features/billing/models";
import {
  getCancellationDiscount,
  getPatientCurrentSubscriptions,
} from "./subscriptions";

export const billingQueriesStore = createQueryKeys("billing", {
  subscriptions: {
    queryKey: null,
    contextQueries: {
      active: {
        queryKey: null,
        queryFn: getPatientCurrentSubscriptions,
      },

      cancellationDiscount: (subscriptionId: Subscription["id"]) => ({
        queryKey: [subscriptionId],
        queryFn: () => getCancellationDiscount(subscriptionId),
      }),
    },
  },

  payments: {
    queryKey: null,
    contextQueries: {
      history: {
        queryKey: null,
        queryFn: getPaymentHistory,
      },

      method: {
        queryKey: null,
        queryFn: getPaymentMethod,
      },
    },
  },
});
